import React from 'react';

export default function BrandLogo({ name = 'notreen' }) {
  return (
    <div className="brand-logo" aria-label={name}>
      <img src="/logo.svg" alt="" />
      <span>{name}</span>
    </div>
  );
}
